import React, { useLayoutEffect } from "react";

export function useAutoResizeTextarea(
    ref: React.RefObject<HTMLTextAreaElement>,
    deps: unknown[] = []
) {
    useLayoutEffect(() => {
        const el = ref.current;
        if (!el) return;

        const resize = () => {
            const styles = window.getComputedStyle(el);
            const padding = parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);
            const borders = parseFloat(styles.borderTopWidth) + parseFloat(styles.borderBottomWidth);

            // Measure without a scrollbar so its width cannot introduce extra wrapping.
            el.style.overflowY = "hidden";
            el.style.height = "auto";
            const height = styles.boxSizing === "border-box"
                ? el.scrollHeight + borders
                : el.scrollHeight - padding;
            el.style.height = `${Math.ceil(height)}px`;
            el.style.overflowY = el.scrollHeight > el.clientHeight ? "auto" : "hidden";
        };

        resize();
        window.addEventListener("resize", resize);
        return () => window.removeEventListener("resize", resize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}